var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-navbar',{attrs:{"name":_vm.currentUserName,"location":_vm.currentLocation},on:{"on-logout":_vm.onLogoutRequest,"on-cash_out":_vm.onCashOut}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }